import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const MergeIcon: React.FC<Props> = ({ color = theme.colors.text }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.21379 9.49085C2.85213 9.99992 3.79095 9.99992 5.6686 9.99992C5.85264 9.99992 6.00193 10.1492 6.00193 10.3333C6.00193 12.2109 6.00193 13.1497 6.51099 13.7881C6.61993 13.9247 6.74387 14.0486 6.88047 14.1575C7.5188 14.6666 8.4576 14.6666 10.3353 14.6666C12.2129 14.6666 13.1517 14.6666 13.7901 14.1575C13.9267 14.0486 14.0506 13.9247 14.1595 13.7881C14.6686 13.1497 14.6686 12.2109 14.6686 10.3333C14.6686 8.45558 14.6686 7.51678 14.1595 6.87845C14.0506 6.74185 13.9267 6.61791 13.7901 6.50898C13.1517 5.99992 12.2129 5.99992 10.3353 5.99992C10.1513 5.99992 10.0019 5.85057 10.0019 5.66659C10.0019 3.78894 10.0019 2.85012 9.49287 2.21178C9.38393 2.07518 9.26 1.95125 9.1234 1.84231C8.48507 1.33325 7.54627 1.33325 5.6686 1.33325C3.79095 1.33325 2.85213 1.33325 2.21379 1.84231C2.07719 1.95125 1.95326 2.07518 1.84433 2.21178C1.33527 2.85012 1.33527 3.78894 1.33527 5.66659C1.33527 7.54425 1.33527 8.48305 1.84433 9.12139C1.95326 9.25799 2.07719 9.38192 2.21379 9.49085Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M4 7H5.49999M4 4H7"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M9 12H10.5M9 9H12"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
